import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import AdSenseSlot from 'components/AdSlots/AdSenseSlot';

const ArticleSidebarAdSlot = ({ slotId, className }) => (
  <AdSenseSlot
    className={twMerge('min-h-[250px]', className)}
    data-full-width-responsive="true"
    format="auto"
    height={250}
    slotId={slotId}
    autoHeight
  />
);

ArticleSidebarAdSlot.displayName = 'ArticleSidebarAdSlot';

ArticleSidebarAdSlot.propTypes = {
  slotId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ArticleSidebarAdSlot;
